import { Col, Form, Input, Row } from "antd"
import React, { Fragment } from "react"
import { translate } from "react-i18next"
import { compose } from "redux"
import { formItemLayout } from "../ConnectionControl"
import { isPortValid } from "../validateUtils"

const FormDBTypeMYSQL = ({
    t,
    form,
}) => {

    return (
        <Fragment>
            <Col>
                <Row>
                    <Form.Item
                        label="Server:"
                        className="form-item-required"
                        {...formItemLayout}
                        >
                        {form.getFieldDecorator('server')(
                            <Input/>
                        )}
                    </Form.Item>
                </Row>
            </Col>
            <Col>
                <Row>
                    <Form.Item
                        label="Database:"
                        className="form-item-required"
                        {...formItemLayout}
                        >
                        {form.getFieldDecorator('database')(
                            <Input/>
                        )}
                    </Form.Item>
                </Row>
            </Col>
            <Col>
                <Row>
                    <Form.Item
                        label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mySql.port')}
                        {...formItemLayout}
                        validateStatus={form.getFieldValue('port') && isPortValid(t, form.getFieldValue('port')).help ? "warning" : null}
                        help={form.getFieldValue('port') && isPortValid(t, form.getFieldValue('port')).help}    
                        >
                        {form.getFieldDecorator('port')(
                            <Input
                                type="number"
                            />
                        )}
                    </Form.Item>
                </Row>
            </Col>
            <Col>
                <Row>
                    <Form.Item
                        label="User ID:"
                        className="form-item-required"
                        {...formItemLayout}
                        >
                        {form.getFieldDecorator('userId')(
                            <Input
                            type="text"
                            />
                        )}
                    </Form.Item>
                </Row>
            </Col>
            <Col>
                <Row>
                    <Form.Item
                        label="Password:"
                        className="form-item-required"
                        {...formItemLayout}
                        >
                        {form.getFieldDecorator('password')(
                            <Input
                            type="password"
                            />
                        )}
                    </Form.Item>
                </Row>
            </Col>
        </Fragment>
    )
}

export default compose(
    translate()
)(FormDBTypeMYSQL)